import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesParcelDeclarationMain } from './modules/ui/Main';

const ParcelDeclarationPage = (
  <SuspensePage>
    <PagesParcelDeclarationMain />
  </SuspensePage>
);

export default ParcelDeclarationPage;
